var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventLead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89.9999,
    height: 89.9999,
    rx: 15,
    transform: "matrix(0.707107 0.707106 -0.707107 0.707106 64 0)",
    fill: "#B39200"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 33.6396,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "#FFFAE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.75 55.3271C68.75 56.5869 68.2496 57.7951 67.3588 58.6859C66.468 59.5767 65.2598 60.0771 64 60.0771C62.7402 60.0771 61.532 59.5767 60.6412 58.6859C59.7504 57.7951 59.25 56.5869 59.25 55.3271C59.25 54.0674 59.7504 52.8592 60.6412 51.9684C61.532 51.0776 62.7402 50.5771 64 50.5771C65.2598 50.5771 66.468 51.0776 67.3588 51.9684C68.2496 52.8592 68.75 54.0674 68.75 55.3271ZM72.3125 55.3271C72.3125 57.5318 71.4367 59.6461 69.8778 61.205C68.3189 62.7639 66.2046 63.6396 64 63.6396C61.7954 63.6396 59.6811 62.7639 58.1222 61.205C56.5633 59.6461 55.6875 57.5318 55.6875 55.3271C55.6875 53.1225 56.5633 51.0082 58.1222 49.4493C59.6811 47.8904 61.7954 47.0146 64 47.0146C66.2046 47.0146 68.3189 47.8904 69.8778 49.4493C71.4367 51.0082 72.3125 53.1225 72.3125 55.3271ZM50.9375 74.3271C50.9375 73.8426 51.46 72.4058 54.0725 70.862C56.4902 69.4346 60.01 68.3896 64 68.3896C67.99 68.3896 71.5098 69.4346 73.9275 70.862C76.54 72.4058 77.0625 73.8426 77.0625 74.3271C77.0625 74.957 76.8123 75.5611 76.3669 76.0065C75.9215 76.4519 75.3174 76.7021 74.6875 76.7021H53.3125C52.6826 76.7021 52.0785 76.4519 51.6331 76.0065C51.1877 75.5611 50.9375 74.957 50.9375 74.3271ZM64 64.8271C54.8563 64.8271 47.375 69.5771 47.375 74.3271C47.375 75.9019 48.0006 77.4121 49.1141 78.5256C50.2276 79.6391 51.7378 80.2646 53.3125 80.2646H74.6875C76.2622 80.2646 77.7724 79.6391 78.8859 78.5256C79.9994 77.4121 80.625 75.9019 80.625 74.3271C80.625 69.5771 73.1437 64.8271 64 64.8271Z",
    fill: "#B39200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventLead);
export default __webpack_public_path__ + "static/media/canvas_event_lead.3430ff3f2aa11995018856d1551402d4.svg";
export { ForwardRef as ReactComponent };